import React from 'react'
import { ILearningResourceCategory } from 'marketing-site/@types/generated/contentful'
import { LearnLinks } from '../links'
import { EditorialStories } from '../editorialStories'
import { transformLearnLink } from 'marketing-site/src/transformers/components/ContentfulLearnLinks'
import { transformCustomerStoryGrid } from 'marketing-site/src/transformers/components/ContentfulEditorialStoryGrid'
import { getSlug } from 'marketing-site/src/transformers/Topic'

export const ResourcesByCategory: React.FC<{ categories: ILearningResourceCategory[] }> = ({
  categories,
}) => {
  const isTheLastItem = (index: number) => index >= categories.length - 1

  if (!categories || categories.length === 0) return null
  return (
    <>
      {categories
        .sort(
          (prevCategory, nextCategory) =>
            prevCategory.fields.positionOnComponent - nextCategory.fields.positionOnComponent,
        )
        .map((category, index) => {
          const headingId = `category-heading-${category.fields.slug}`
          return (
            <div role="group" key={index} aria-labelledby={headingId}>
              {category.fields.resources && (
                <LearnLinks
                  headline={category.fields.name}
                  links={transformLearnLink(category.fields.resources.slice(0, 3))}
                  viewAll={getSlug(category.fields.slug, category.fields.viewAllUrl)}
                  appearance="Large Cards"
                  background="transparent"
                  asFullGrid
                />
              )}
              {category.fields.editorialStoryGrid && (
                <EditorialStories
                  headline={category.fields.name}
                  slug={getSlug(category.fields.slug, category.fields.viewAllUrl)}
                  customerStoryGrid={transformCustomerStoryGrid(category.fields.editorialStoryGrid)}
                  includeMagicLine={!isTheLastItem(index)}
                />
              )}
            </div>
          )
        })}

      <style jsx>{`
        div[role='group'] {
          margin-top: 5rem;
        }

        :global(.learn-links__wrap.learn-links__wrap-large-cards) {
          padding: 0;
        }
      `}</style>
    </>
  )
}
